import { resizeObservers } from '../utils/resizeObservers';
/**
 * Checks to see if there are any skipped observations.
 * This is used to deliver the resize loop error.
 *
 * https://drafts.csswg.org/resize-observer-1/#has-skipped-observations-h
 */
var hasSkippedObservations = function () {
    return resizeObservers.some(function (ro) { return ro.skippedTargets.length > 0; });
};
export { hasSkippedObservations };
